import {
  LIST_STATUS_TEMPLATE,
  GET_TEMPLATE_ID,
  DOWNLOAD_CONTRACT,
  SEND_CONTRACT_URL,
  TRACK_SENT_CONTRACT_URL,
} from "@/utils/constants/constants.js";
import axios from "axios";
import $ from "jquery";

export default {
  data: () => ({
    verification_data: [],
    preview_contract_data: null,
    template_id: null,
    form_sent: false,
    submission_ids: [],
    current_submission_id: null,
    sending_contract: false,
    contract_status_data: null,
    document_has_been_sent: false,
    template_error: null,
    send_contract_error: null,
    contract_already_sent: false,
    last_submission_data: null,
    document_was_sent: false,
    is_downloading: false,
    is_sending: false,
    show_send_confirmation: false,
    current_step: 1,
  }),
  methods: {
    async get_assigned_templates() {
      this.loading_templates = true;
      try {
        const response = await axios.get(LIST_STATUS_TEMPLATE, {
          headers: this.headers,
          params: {
            project_id: this.project_id,
            application_id: this.received_application_id,
            form_id: this.received_form_id,
          },
        });

        if (!response.data?.data) {
          this.show_error("No data in response");
          return;
        }

        this.verification_data = this.process_template_response(
          response.data.data
        );
        this.document_was_sent = this.verification_data.some(
          (item) => item.was_sent || item.status === "sent"
        );

        this.verification_data.forEach((_, index) => {
          this.accordion_open.set(index, false);
        });
      } catch (error) {
        this.show_error(
          "Error fetching templates: " +
          (error.response?.data?.message || error.message)
        );
        this.verification_data = [];
      } finally {
        this.loading_templates = false;
      }
    },

    process_template_response(data) {
      if (!data) return [];

      let templates_data = [];
      if (Array.isArray(data)) {
        templates_data = data;
      } else if (data.active_assignments) {
        templates_data = Array.isArray(data.active_assignments)
          ? data.active_assignments
          : [];
      }

      return templates_data.map((template) => {
        const template_obj = template.template || template;
        const uploaded_raw =
          template_obj.created_at || new Date().toISOString();
        const modified_raw = template_obj.updated_at || uploaded_raw;

        return {
          id: template_obj.id || null,
          template_id: template_obj.id || null,
          name: template_obj.name || "Unnamed Template",
          file_type: template_obj.file_type || "PDF",
          date_uploaded: new Date(uploaded_raw).toLocaleString(),
          date_modified: new Date(modified_raw).toLocaleString(),
          document_url: template_obj.document_url || null,
          presigned_url: template_obj.presigned_url || null,
          version: template_obj.version || 1,
          status: template_obj.status || "Signed",
          was_sent: template_obj.was_sent || false,
        };
      });
    },

    async get_template_id() {
      if (
        !this.received_profile_role_id &&
        !this.received_application_id
      ) {
        this.show_error("No profile role ID or form ID found");
        return null;
      }

      const response = await axios
        .post(
          GET_TEMPLATE_ID,
          {
            profile_role_id: this.received_profile_role_id,
            application_id: this.received_application_id,
            form_id: this.received_form_id || this.preview_contract_data?.id,
            project_id: this.project_id,
          },
          { headers: this.headers }
        )
        .catch((error) => {
          const error_msg =
            error.response?.data?.error ||
            error.message ||
            "Failed to fetch template ID";
          this.show_error(error_msg);
          return null;
        });

      if (!response) return null;

      if (response.data.template_id) {
        this.template_id = response.data.template_id;
        return this.template_id;
      }

      this.show_error(response.data.error || "Failed to get template ID");
      return null;
    },

    async fetch_contract_status() {
      if (!this.current_submission_id) {
        return null;
      }

      const response = await axios.post(
        TRACK_SENT_CONTRACT_URL,
        {
          application_id: this.received_application_id,
          form_id: this.received_form_id || this.preview_contract_data?.id,
          submission_id: this.current_submission_id,
          project_id: this.project_id,
        },
        {
          headers: this.headers,
          params: { submission_id: this.current_submission_id },
        }
      );

      if (!response.data) {
        return null;
      }

      this.process_contract_status(response.data);
      return response.data;
    },

    process_contract_status(data) {
      this.contract_status_data = data;
      this.contract_already_sent = true;
      this.form_sent = true;

      if (data.signers) {
        this.signers = data.signers.map((signer) => ({
          ...signer,
          full_name: `${signer.name} ${signer.surname}`.trim(),
        }));
      }

      if (data.timeline) {
        this.timeline = data.timeline.map((event) => ({
          ...event,
          description: this.format_timeline_description(event.description),
          formatted_date: this.format_date_time(event.timestamp),
        }));
      }

      if (this.last_submission_data) {
        this.last_submission_data.timeline = this.timeline;
        this.last_submission_data.signers = this.signers;
      }
    },

    async send_contract_to_founder() {
      this.sending_contract = true;
      this.send_contract_error = null;

      if (
        !this.profile_role_id ||
        !this.current_submission_id ||
        !this.user_id ||
        !this.template_id
      ) {
        this.sending_contract = false;
        this.show_error(
          "Missing required IDs (profile_role_id, submission_id, user_id, or template_id)"
        );
        return;
      }

      const request_data = {
        profile_role_id: this.profile_role_id,
        form_id: this.form_id,
        user_id: this.user_id,
        project_id: this.project_id,
      };

      try {
        const response = await axios.post(SEND_CONTRACT_URL, request_data, {
          headers: this.headers,
          params: {
            submission_id: this.current_submission_id,
            template_id: this.template_id,
          },
        });

        this.update_route_after_sending();
        this.show_success(
          response.data.message || "Contract sent successfully!"
        );
        this.form_sent = true;
        this.show_contract_management = true;

        const status_data = await this.fetch_contract_status();
        if (status_data) {
          this.add_timeline_event({
            event_type: "Sent",
            description: `Document sent to ${this.founder_name}`,
            timestamp: new Date().toISOString(),
            user: this.founder_name,
          });
        }
      } catch (error) {
        this.send_contract_error = error.response?.data?.error || error.message;
        this.show_error(this.send_contract_error);
      } finally {
        this.sending_contract = false;
      }
    },

    async download_contract() {
      this.is_downloading = true;
      this.download_error = null;

      if (!this.current_submission_id) {
        this.is_downloading = false;
        this.show_error("Missing required submission ID");
        return;
      }

      try {
        const response = await axios.get(DOWNLOAD_CONTRACT, {
          headers: this.headers,
          params: {
            submission_id: this.current_submission_id,
            project_id: this.project_id,
          },
          responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `contract_${this.current_submission_id}.pdf`
        );
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.show_success("Contract downloaded successfully!");
      } catch (error) {
        const error_message = await this.get_download_error_message(error);
        this.show_error(error_message);
      } finally {
        this.is_downloading = false;
      }
    },

    async get_download_error_message(error) {
      if (error.response?.headers["content-type"]?.includes("application/json"))
        return JSON.parse(await error.response.data.text()).error ||
          JSON.parse(await error.response.data.text()).message ||
          error.message;

      return error.response?.data?.error || error.message;
    },

    update_route_after_sending() {
      this.$router.push({
        query: {
          ...this.$route.query,
          contract_sent: "true",
          current_submission_id: this.current_submission_id,
        },
      });
    },

    initiate_send_flow() {
      this.show_send_confirmation = true;
      this.current_step = 2;
      this.$nextTick(() => {
        const element = $(".signers-list-contracts")[0];
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      });
    },

    async send_to_all_signers() {
      this.is_sending = true;
      try {
        await this.send_contract_to_founder();
        this.show_send_confirmation = false;
        this.current_step = 3;
      } catch (error) {
        this.show_error(
          "Failed to send contract: " +
          (error.response?.data?.message || error.message)
        );
      } finally {
        this.is_sending = false;
      }
    },

    format_timeline_description(description) {
      if (!description) return "";
      const email_match = description.match(/sent to (.+)$/);
      if (email_match?.[1]) {
        const email = email_match[1];
        const signer = this.signers.find((s) => s.email === email);
        if (signer) {
          return `Document sent to ${signer.name} ${signer.surname}`;
        }
      }
      return description;
    },

    format_date_time(timestamp) {
      if (!timestamp) return "";
      return new Date(timestamp).toLocaleString();
    },

    add_timeline_event(event) {
      if (!event) return;

      const formatted_event = {
        ...event,
        description: this.format_timeline_description(event.description),
        formatted_date: this.format_date_time(event.timestamp),
      };

      this.timeline.unshift(formatted_event);
      this.timeline.sort(
        (a, b) => new Date(b.timestamp) - new Date(a.timestamp)
      );

      if (this.last_submission_data) {
        this.last_submission_data.timeline = this.timeline;
      }
    },
  },
};
